var e={pageIndicator_one:"of 1 page",pageIndicator_other:"of {{count}} pages",error:"Failed to load PDF",error401:"Please log in to view this file",error403:"You do not have permission to view this file"},o={pdfViewer:e};export{o as default,e as pdfViewer};
//# sourceMappingURL=en-US.json.js.map
